import Catalog from "./components/Catalog/Catalog";
import QuickCart from "./components/QuickCart";
import { FittingRequestPopup } from "./components/FittingRequest";

function onReady()
{
    // Быстрое добавление в корзину в списках
    new QuickCart();

    // Примерка в 1 клик
    document.querySelectorAll('[data-entity="fitting-request"]')
        .forEach(rootNode => new FittingRequestPopup(rootNode, { showAfter: 1000 }));
}

if (document.readyState !== 'loading') {
    setTimeout(onReady, 0);
} else {
    document.addEventListener('DOMContentLoaded', () => onReady());
}

if (!window.loadNextPage) {
    window.loadNextPage = function(event) {
        event.preventDefault();
    
        let $this = $(event.target),
            replaceable = $this.parent(),
            page = $this.data('url');
    
        $this.addClass('btn-progress').prop('disabled', true);
    
        Catalog.load(page, {}, function (result) {
            if (result !== false) {
                replaceable.replaceWith(result.find('.js-products').html());
    
                if (typeof BX !== 'undefined' && BX.ajax?.history) {
                    let urlObj = new URL(page, window.location.href);
                    urlObj.searchParams.delete('bId');
                    let url = urlObj.pathname + urlObj.search + urlObj.hash;
                    
                    BX.ajax.history.put({ url }, url);
                }
    
                $('.js-products').trigger('mario.catalog.reloaded');
            } else {
                $this.removeClass('btn-progress').prop('disabled', false);
            }
        });
    };
}